
var extend = require('extend');
var state = require('../state').native

var defaultPkg = {
    pkg: '',// 'com.tencent.synopsis',
    pkgurl: '',// 'synopsis://',
    downloadUrl: '', // http://mcgi.v.qq.com/commdatav2?cmd=69&confid={confid}&platform=aphone
    iconUrl: '',
    appName: '',
    confid:''
}

/**
 * 下载进度条，只支持腾讯视频
 */
var TxvDownloader = function (config) {
    this.config = extend(defaultPkg, config)
    this.onProgeressEvents = []
    this.onTaskEvents = []
    this._initEvt()
}


TxvDownloader.prototype._initEvt = function () {
    var me = this;
    util.ready(function (bridge) {
        bridge.on('onDownloadTaskProgressChanged', function (res) {
            res = util.parse(res)
            if (res.packageName === me.config.pkg) {
                me.onProgeressEvents.forEach(function (evt) {
                    evt && evt(parseInt(res.progress), res)
                })
            }
        })
        bridge.on('onDownloadTaskStateChanged', function (res) {
            res = util.parse(res)
            if (0 === res.errorCode && res.packageName === me.config.pkg) {
                me.onTaskEvents.forEach(function (evt) {
                    evt && evt(res.state)
                })
            }
        })
    })
}

/**
 * 下载任务状态改变事件
 */
TxvDownloader.prototype.onTaskChange = function (cb) {
    if (this.onTaskEvents.indexOf(cb) <= -1) {
        this.onTaskEvents.push(cb)
    } else {
        console.log(String(cb) + 'has in onTaskChange events')
    }
}

/**
 * 进度改变事件
 * @param  cb {(progress:number,raw:object)=>void}  
 */
TxvDownloader.prototype.onProgressChange = function (cb) {
    if (this.onProgeressEvents.indexOf(cb) <= -1) {
        this.onProgeressEvents.push(cb)
    } else {
        console.log(String(cb) + 'has in onProgressChange events')
    }
}

TxvDownloader.prototype.pause = function () {
    var me = this;
    util.ready(function (bridge) {
        bridge.invoke('pauseDowload3rdApp', {
            "downloadUrl": me.config.downloadUrl,
            "packageName": me.config.pkg
        })
    })
}

TxvDownloader.prototype.cancel = function () {
    var me = this;
    util.ready(function (bridge) {
        bridge.invoke('cancelDowload3rdApp', {
            "downloadUrl": me.config.downloadUrl,
            "packageName": me.config.pkg
        })
    })
}

TxvDownloader.prototype.check = function (cb) {
    var me = this;
    util.ready(function (bridge) {
        bridge.invoke('isInstalled', {
            "pkgName": me.config.pkg,
            "pkgUrl": me.config.pkgurl
        }, function (res) {
            res = util.parse(res)
            cb && cb(!!res.result.installed)
            // console.log('TxvDownloader', res.result)
        })
    })
}

TxvDownloader.prototype.start = function (opt) {
    opt=opt||{}
    var me = this;
    if (!opt.confid  && !me.config.confid) {
        throw new Error('txv downloader:need confid');
    }
    if(opt.confid){
        me.config.confid=opt.confid;
    }
    util.ready(function (bridge) {
        me.config.downloadUrl = me.config.downloadUrl.replace('{confid}', me.config.confid);
        var param = {
            "downloadUrl": me.config.downloadUrl,
            "packageName": me.config.pkg,
            "iconUrl": me.config.icon,
            "appName": me.config.name,
            "itunesUrl": me.config.downloadUrl,
            "packageUrl": "",
            "channel": ""
        }
        // console.log('download3rdApp start',JSOsN.stringify(param))
        bridge.invoke("download3rdApp", param, function (res) {
            // debugger
            // console.log('download3rdApp', res)
        });
    })
}

TxvDownloader.prototype.open = function (openurl) {
    var me = this;
    util.ready(function (bridge) {
        var p = {
            "pkgName": me.config.pkg,
            "pkgUrl": me.config.pkgurl,
            "schemeUrl": openurl,
            "appName": me.config.name
        }
        console.log('openp ', p)
        bridge.invoke('launch3rdApp', p, function (res) {
            // console.log('launch3rdApp', res)
            // me.start()
        })
    })
}
TxvDownloader.prototype.install =function(){
    this.start()
}
TxvDownloader.prototype.restart = function () {
    this.cancel()
    // maybe async
    setTimeout(function () {
        this.start()
    }, 0);
}

var util = {
    ready: function (callback) {
        if (window.TenvideoJSBridge) {
            callback && callback(window.TenvideoJSBridge);
        } else {
            document.addEventListener('onTenvideoJSBridgeReady', function () {
                callback && callback(window.TenvideoJSBridge);
            });
        }
    },
    parse: function (ret) {
        if (ret) {
            if ('string' === typeof ret) {
                try {
                    ret = decodeURIComponent(ret);
                } catch (e) { }
                ret = JSON.parse(ret);
            }
        }
        return ret;
    }

}

TxvDownloader.STATE = {
    /** 10 下载并安装*/
    installed: 10,
    /**  11 下载未安装*/
    download_Without_Installed: 11,
    /** 12 取消下载 */
    cancel: 12,
    /** 13 开始下载或下载中 */
    downloading: 13,
    /** 14 暂停 */
    pause: 14,
    /** 16 等待下载 */
    waiting: 16
}

var map = {
    10: state.INSTALLED,
    11: state.DOWNLOADED,// 下载完成未安装
    12: state.CANCEL,
    13: state.DOWNLOADING,
    14: state.PAUSE
}

module.exports = function (native, _callback) {
    try {
        var downloader = new TxvDownloader(native.package)
        downloader.onProgressChange(function (p) {
            native.emit('progress', p)
        })
        downloader.onTaskChange(function (state) {
            console.log('TxvDownloader',state)
            if (map[state]) {
                native.state = map[state]
            }
        })
        _callback(downloader)
    } catch (error) {
        console.error(error)
    }
}


///https://itunes.apple.com/cn/app/id458318329?mt=8?openurl=http%3A%2F%2Fv.qq.com